import api from '../api';

export const getRecalculateIROG = async () => {
	const url = '/horaHora/updateAllIrogs';
	const response = await api.get(url);
	return response.data;
};
